import React, {forwardRef} from 'react'
import PropTypes from 'prop-types'
import {MenuList} from '@chakra-ui/react'
import {motion} from 'framer-motion'

const MenuTransition = motion.div

const A11yMenuList = forwardRef(
    (
        {
            // as per https://hub.accessible360.com/kb/articles/529#heading-navigation-menus-are-not-application-menus
            // we should not use role="menu" on the menu list and navigation should be based on tab
            // so we remove the onKeyDown handler which prevents the tab key from working
            role,
            onKeyDown,
            ...props
        },
        ref
    ) => <MenuTransition ref={ref} {...props} />
)

if (process.env.NODE_ENV !== 'production') {
    A11yMenuList.displayName = 'A11yMenuList'
}

A11yMenuList.propTypes = {
    role: PropTypes.string,
    onKeyDown: PropTypes.func
}

const StokkeMenuList = ({as, ...props}) => {
    return <MenuList {...props} as={A11yMenuList} propagateAs={as} />
}

StokkeMenuList.propTypes = {
    as: PropTypes.elementType
}

export default StokkeMenuList
